import { ConversionConstructedNoDates } from "@/types/types";
import { isConversionMulti } from "@/utils/isConversionMulti";
import { isConversionMultiConversion } from "@/utils/isConversionMultiConversion";

export const constructConversionMultis = (
  conversions: ConversionConstructedNoDates[]
): (ConversionConstructedNoDates | ConversionConstructedNoDates[])[] => {
  const conversionMultis: Record<string, ConversionConstructedNoDates[]> = {};

  const conversionNotMultis: ConversionConstructedNoDates[] = [];

  conversions.forEach((conversion) => {
    if (isConversionMultiConversion(conversion)) {
      if (conversionMultis[conversion.conversionMultiId] === undefined) {
        conversionMultis[conversion.conversionMultiId] = [];
      }

      conversionMultis[conversion.conversionMultiId].push(conversion);
    } else {
      conversionNotMultis.push(conversion);
    }
  });

  const conversionMultisArray = Object.values(conversionMultis);
  const returnArray: (
    | ConversionConstructedNoDates
    | ConversionConstructedNoDates[]
  )[] = [...conversionNotMultis, ...conversionMultisArray];

  // Sort the returnArray
  returnArray.forEach((conversion) => {
    if (isConversionMulti(conversion)) {
      conversion.sort((a, b) => {
        const aDate = new Date(a.createdAtString);
        const bDate = new Date(b.createdAtString);

        return bDate.getTime() - aDate.getTime();
      });
    }
  });

  returnArray.sort((a, b) => {
    let aDate: Date;
    let bDate: Date;
    if (isConversionMulti(a)) {
      if (a.length === 0) {
        return 1;
      }

      aDate = new Date(a[0].createdAtString);
    } else {
      aDate = new Date(a.createdAtString);
    }

    if (isConversionMulti(b)) {
      if (b.length === 0) {
        return -1;
      }

      bDate = new Date(b[0].createdAtString);
    } else {
      bDate = new Date(b.createdAtString);
    }

    return bDate.getTime() - aDate.getTime();
  });

  return returnArray;
};
